import axios from 'axios';

export const exportDataset = async (filter) => {
  const token = localStorage.getItem('idToken');
  const res = await axios.get('http://localhost:8001/api/photos/export', {
    params: { filter },
    responseType: 'blob',
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data; // Blob
};
